import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

import chart from './simulatechart'

export default {
  name: 'predict',

  components: {
    chart
  },

  data() {
    return {
      // カスタム入力欄の値引率と入荷数の配列(v-model)
      customOffrateWeek: [],
      customArrivalWeek: []
    }
  },

  watch: {
    skuId(oldSku, newSku) {
      if (oldSku != newSku) this.resetGraphScrollPosition()
    },
    itemId(oldItem, newItem) {
      if (oldItem != newItem) this.resetGraphScrollPosition()
    }
  },

  computed: {
    ...mapGetters('category', ['category']),
    ...mapGetters('detail', ['categoryId']),

    ...mapGetters('predict', [
      'itemId',
      'skuId',
      'lifeCycle',
      'item',
      'skus',
      'predictItemMain',
      'mainSku'
    ]),

    /**
     * チャート描画用データ。データがない場合は空データを返却
     * 全然関係ないが、Vuex更新時にカスタム入力欄の値引率と入荷数の描画も行う
     */
    chartdata() {
      const labels = this.getVal_('date_labels')
      const data = {
        labels: [],
        acutual: [],
        predict: [],
        custom: [],
        accum: [],
        offrate: []
      }

      if (labels) {
        data.labels = labels
        data.acutual = this.convertChart_(this.getVal_('actual_sales'))
        data.predict = this.convertChart_(this.getVal_('predict_sales'))
        data.custom = this.convertChart_(this.getVal_('custom_sales'))
        data.accum = this.getVal_('accum_arrival')
        data.offrate = this.getMiniOffrate(this.getVal_('off_rates'))
      }

      // 値引率と入荷数を更新
      this.offrates_()
      this.arrival_()
      return this.getChart_(data)
    },

    /**
     * チャート描画範囲をチャートの長さに合わせたcssを返す
     * overflowと合わせて横長チャートでも画面内で納めるようにしている
     */
    cssGraphArea() {
      const labels = this.getVal_('date_labels')
      const weekLength = labels ? labels.length : 0
      return `width: ${15 * weekLength}px; height: 400px;`
    },

    /**
     * カスタム入力欄をチャートの長さに合わせたcssを返す
     * チャートの週日付と縦に揃うように調整している
     */
    cssBoxAreaWidth() {
      const labels = this.getVal_('date_labels')
      const weekLength = labels ? labels.length : 0
      return `width: ${70 + 15 * weekLength}px;`
    }
  },

  methods: {
    ...mapActions('predict', [
      'getCustomItem',
      'getCustomSku'
    ]),

    /**
     * カスタム入力欄の値引率に設定する値を設定
     * カスタム入力欄はv-modelなのでcomputedに指定できないため他のcomputedから呼び出し
     */
    offrates_() {
      const offRates = this.getVal_('off_rates')
      this.customOffrateWeek = this.getWeekOffrate_(offRates)
    },

    /**
     * カスタム入力欄の入荷数に設定する値を設定
     */
    arrival_() {
      const accumArrival = this.getVal_('accum_arrival')
      this.customArrivalWeek = this.getWeekArrival_(accumArrival)
    },

    /**
     * 特定の項目を取得する共通メソッド
     * 取得対象がitem単位かsku単位かを判定して返却する
     */
    getVal_(key) {
      const id = this.skuId
      return id ? this.skus[id][key] : this.item[key]
    },

    /**
     * カスタム入力欄は週で描画されるため週配列を返却
     * 描画上、1週目は描画しないため含めない
     */
    getWeekValue_(list) {
      if (!list) return

      const z = []
      for (let i = 7, len = list.length; i < len; i += 7) {
        z.push(list[i])
      }
      return z
    },

    /**
     * カスタム入力欄の値引率は週で合計した値を割った週配列を返却
     * 描画上、1週目は描画しないため含めない
     */
    getWeekOffrate_(list) {
      if (!list) return

      const z = []
      for (let i = 7, len = list.length; i < len; i += 7) {
        const w = i + 6 >= len ? len - i - 1 : 6
        let sumOffrate = 0
        for (let j = i; j <= i + w; j++) {
          sumOffrate += list[j]
        }
        z.push(parseInt(sumOffrate / (w + 1)))
      }
      return z
    },

    /**
     * カスタム入力欄の入荷数は週差の週配列を返却
     * 描画上、1週目は描画しないため含めない
     */
    getWeekArrival_(list) {
      if (!list) return

      const z = []
      for (let i = 7, len = list.length; i < len; i += 7) {
        const w = i + 6 >= len ? len - i - 1 : 6
        z.push(list[i + w] - list[i - 1])
      }
      return z
    },

    /**
     * チャートのツールチップ用にoffrateをグラフデータに追加するが、
     * 描画に影響しないように100で割った数値を取得
     */
    getMiniOffrate(list) {
      if (!list) return

      const z = []
      _.forEach(list, val => z.push(val / 100))
      return z
    },

    /**
     * チャートの折れ線グラフは累積のため、累積配列を返却
     */
    convertChart_(data) {
      if (!data) return

      const list = []
      _(data).reduce((sum, val) => {
        sum += val
        list.push(sum)
        return sum
      }, 0)
      return list
    },

    /**
     * chart.js用オブジェクトに変換して返却
     */
    getChart_(data) {
      const chart = {
        labels: data.labels,
        backgroundColor: 'white',
        datasets: [
          {
            label: '実績',
            pointRadius: 0,
            borderColor: '#0b7bfe',
            data: data.acutual
          }, {
            label: '予測',
            pointRadius: 0,
            borderColor: '#85bcfc',
            data: data.predict
          }, {
            label: 'カスタム予測',
            pointRadius: 0,
            borderColor: '#ffb93f',
            data: data.custom
          }, {
            label: '累積入荷数',
            pointRadius: 0,
            borderColor: '#717a90',
            data: data.accum
          }, {
            label: 'オフ率',
            pointRadius: 0,
            pointHitRadius: 0,
            pointHoverRadius: 0,
            showLine: false,
            borderColor: '#fff',
            data: data.offrate
          }
        ]
      }
      return chart
    },

    /**
     * カスタム予測実行
     * カスタム入力欄の設定値から値引率と入荷数の配列を構築し、APIに問い合わせ
     * item単位の場合は、skuごとに配列を構築
     * 値引率はitem単位の場合、日付に合わせてskuの値引率配列を構築する
     * 入荷数はitem単位の場合、sku数で均等に割り、余りは先頭skuに追加する
     */
    async onCustomPredict() {
      // 実行前精査
      if (this.isInputOffrate_() || this.isInputArrival_()) {
        return
      }

      const id = this.skuId
      const label = this.getVal_('date_labels')
      const weekLabel = this.getWeekValue_(label)

      if (id) {
        await this.getCustomSku({
          skuId: id,
          data: this.createPredictData_(id, weekLabel, label, 1, true)
        })
      } else {
        const skus = this.skus
        const skuNum = _.size(skus)
        const datas = {}
        let remainder = true

        _.forEach(skus, (sku, skuId) => {
          const skuLabel = sku.date_labels
          datas[skuId] = this.createPredictData_(skuId, weekLabel, skuLabel, skuNum, remainder)
          remainder = false
        })
        await this.getCustomItem({ data: datas })
      }
    },

    /**
     * カスタム予測の値引率精査
     * 前日値引率未満または値引率が最大値引率を超過した場合、エラーとする
     */
    isInputOffrate_() {
      const setOffrate = this.getVal_('set_offrate')
      const maxOffrate = this.category[this.categoryId].over_offrate
      const pw = this.customOffrateWeek
      const labels = this.chartdata.labels
      let flag = false
      let message = ''

      _.forEach(pw, (v, i) => {
        // 入力可能な週のみチェック対象
        if (!this.activeInput(i) && (v === '' || v < setOffrate || maxOffrate < v)) {
          flag = true
          message += `・${labels[(i + 1) * 7]}の値引率に不備があります<br>`
        }
      })

      if (flag) {
        swal({
          html: `値引率は「最小値引率(${setOffrate}) ～ 最大値引率(${maxOffrate})」の範囲で入力してください<br><br>${message}`,
          type: 'error'
        })
      }
      return flag
    },

    /**
     * カスタム予測の入荷数精査
     * 0未満または入荷数が10万以上の場合、エラーとする
     */
    isInputArrival_() {
      const pw = this.customArrivalWeek
      const labels = this.chartdata.labels
      let flag = false
      let message = ''

      _.forEach(pw, (v, i) => {
        // 入力可能な週のみチェック対象
        if (!this.activeInput(i) && 0 !== v && (v < 0 || 100000 <= v)) {
          flag = true
          message += `・${labels[(i + 1) * 7]}の入荷数に不備があります<br>`
        }
      })

      if (flag) {
        swal({
          html: `入荷数は「0 ～ 99,999」の範囲で入力してください<br><br>${message}`,
          type: 'error'
        })
      }
      return flag
    },

    /**
     * カスタム予測APIに投げるリクエストデータを返却
     * 値引率と入荷数について配列を構築
     * item単位の場合は、カスタム設定の開始位置を日付から取得
     */
    createPredictData_(skuId, weekLabel, skuLabel, skuNum, remainder) {
      const accumArrival = this.skus[skuId]['accum_arrival'].slice()
      const offRates = this.skus[skuId]['off_rates'].slice()
      const actualWeek = this.getVal_('actual_week') - 1
      const len = accumArrival.length

      _.forEach(weekLabel, label => {
        const wIdx = weekLabel.indexOf(label)
        const idx = skuLabel.indexOf(label)

        // 当該日付が存在し、実績週以降であれば配列更新
        if (idx !== -1 && (!this.activeInput(wIdx) || actualWeek < wIdx)) {
          const off = parseInt(this.customOffrateWeek[wIdx])
          let arr = Math.floor(this.customArrivalWeek[wIdx] / skuNum)
          if (remainder) {
            arr += Math.floor(this.customArrivalWeek[wIdx] % skuNum)
          }

          const accumArr = arr + accumArrival[idx - 1]
          for (let i = idx; i < idx + 7 && i < len; i++) {
            offRates[i] = off
            accumArrival[i] = accumArr
          }
        }
      })

      return {
        off_rate: offRates,
        arrival: accumArrival
      }
    },

    /**
     * カスタム入力欄の非活性判定
     * 実績が存在する週とライフサイクル週以上は非活性
     */
    activeInput(index) {
      let state = false
      const actualWeek = this.getVal_('actual_week')

      if (index < parseInt(actualWeek - 1)) {
        state = true
      } else if (index >= (this.lifeCycle - 1)) {
        state = true
      }
      return state
    },

    /**
     * カスタム入力欄の各種BOXのレイアウト調整
     */
    boxAreaMargin(index) {
      const margin = 30 + (index >= 10 ? 12 : 15)
      return `margin-left: ${margin}px;`
    },

    /**
     * カスタム入力欄の値引率を変更した場合、後続週に同値を反映
     */
    setAutoOffrate(idx) {
      const val = this.customOffrateWeek[idx]
      for (let i = idx + 1, len = this.customOffrateWeek.length; i < len; i++) {
        this.customOffrateWeek[i] = val
      }

      // コンポーネント再描画(上記は仮想DOMは更新されるが画面は更新されないため)
      this.$forceUpdate()
    },

    createFixedScales(chart) {
      const graphCanvas = chart.canvas
      if (graphCanvas.width === 0) return

      const context = document.getElementById('fixedScales').getContext('2d')
      context.canvas.width = chart.scales['y-axis-0'].width
      context.drawImage(graphCanvas,
        0, 0, graphCanvas.width, graphCanvas.height,
        0, 0, graphCanvas.width, graphCanvas.height)
    },

    resetGraphScrollPosition() {
      const chartArea = document.getElementById('chart-area')
      if (chartArea != null) chartArea.scrollLeft = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/predict/simulate/simulate.js